import React from 'react';
import { Avatar, AvatarProps, Box, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Edit from '@mui/icons-material/Edit';
import { stopEffects } from '../../../lib/Event';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: 'relative',
    '&:hover': {
      '& $editIcon': {
        opacity: 1,
      },
    },
  },
  editIcon: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '50%',
    bottom: -2,
    color: 'white',
    height: '90%',
    left: -6,
    opacity: 0,
    paddingTop: theme.spacing(0.5),
    pointerEvents: 'none',
    position: 'absolute',
    top: 2,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.enteringScreen,
    }),
    width: '115%',
    zIndex: 1,
  },
}));

interface Props extends AvatarProps {
  disabled?: boolean;
  onEdit: () => void;
  siblings?: number;
}

const EditableAvatar = React.forwardRef<HTMLDivElement, Props>(
  (props: Props, ref): JSX.Element => {
    const classes = useStyles();

    const { disabled, onEdit, siblings = 0, ...avatarProps } = props;

    return (
      <Box {...{ ref }} className={classes.container}>
        <Avatar {...avatarProps} />

        {!disabled && (
          <Box
            className={classes.editIcon}
            onClick={stopEffects(onEdit)}
            style={{ zIndex: siblings + 1 }}
          >
            <Edit fontSize="small" />
          </Box>
        )}
      </Box>
    );
  }
);

export default EditableAvatar;
